export const NONE = "none";
export const AUTOMATIC = "automatic";
export const TAG = "tag";
export const INVISIBLE = "invisible";
